<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-27 19:12:16
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.key"
                  size="mini"
                  clearable
                  placeholder="请输入关键字查找" />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   style=" background: #1067e0;border-color: #1067e0;"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <el-button type="primary"
                               icon="el-icon-refresh"
                               @click="syncData">
                   同步
                    </el-button>
        <!-- <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button> -->
        <el-button type="success" plain @click="showImportModal()" >
          导入车场数据
        </el-button>
        <el-button type="warn" plain @click="showchepaipage()" >
          查询车牌信息
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px">
        <el-table-column prop="id"
                         label="id"
                         width="80" />
        <el-table-column prop="resourceName" label="资源名称" minwidth="200" />
        <el-table-column prop="resourceCode" label="资源code" minwidth="200" />
        <el-table-column prop="resourceGroupName" label="资源分组" minwidth="200" />
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="220">
          <template slot-scope="scope">
            <!-- <el-button type="danger"
                       style="
                                    background: #42d885;
                                    border-color: #42d885;
                                "
                       size="mini"
                       @click="clickItem(1, scope.row)">修改</el-button> -->
            <el-button type="danger"
                       style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                       size="mini"
                       @click="clickDetail(scope.row)">详情</el-button>
            <!-- <el-button type="danger"
                       @click="remove(scope.row)"
                       size="mini">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <RoleAdd ref="RoleAdd"
                 @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
    <!-- 详情 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDetail"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ "详情" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <ResourceDetail ref="ResourceDetail"
                 @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
    <el-dialog
      :visible.sync="importmodal"
      title="数据导入"
      >
      <el-form :model="leadIn" ref="leadInValidate" :rules="leadInValidate" action="javascript:void(0)" :label-width="110">
        <el-form-item label="选择文件" prop="filePath">
          <upload-xlsx ref="ImageVideo"
                    :tipInfo="`上传式为'xls,xlxs'`"
                    :image-list="videoDefaultList" :maxNumber="1" @updateImg="onUpdateVideo($event)"></upload-xlsx>
        </el-form-item>
      </el-form>
      <el-button @click="importmodal = false">取 消</el-button>
      <el-button type="primary" @click="importExcel()">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/Qu";
import city from '@/api/tianzheng/city'
import RoleAdd from "./QuAdd.vue";
import ResourceDetail from "./ResourceDetail.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import UploadXlsx from '../../../components/UploadExcel/index.vue'
export default {
  data () {
    return {
      pageLoading:'',
      queryParam: {
        commId: '',
        key: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
      showDetail:false,
      fileList:[],
      importmodal:false,
      videoDefaultList: [],
      videoList: false,

    };
  },
  components: {
    Pagination,
    RoleAdd,
    ResourceDetail,
    UploadXlsx
  },
  created () {
    this.queryParam.commId = this.$route.query.id
  },
  mounted () {
    this.getList();
  },
  methods: {
    // 同步数据
    syncData(){
      const that = this
        that.$confirm('确定同步该小区资源信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 调用接口
            that.pageLoading = Loading.service({
              lock: true,   //是否锁定屏幕的滚动
              text: "加载中……",  //loading下面的文字
              background: "rgba(0, 0, 0, 0.7)",  //loading的背景色
              target:"body"      //loading显示在容器
            });
            fetch.resourceSync({commId:this.queryParam.commId}).then((res) => {
              that.pageLoading.close();
              that.pageLoading = null;
              if (res.code == 200) {
                that.$message.success(res.message)
                that.getList()
              } else {
                that.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            that.pageLoading.close();
              that.pageLoading = null;
          })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc:
 */
    changeStatus (val) {
      let params = {
        role_id: val.id,
        status: val.status
      };
      fetch.status(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.showDetail = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
        this.showDetail = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.showDetail = false;
      if (this.$refs.RoleAdd){
        this.$refs.RoleAdd.resetForm();
      }
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.RoleAdd.initFun(obj);
      });
    },
    clickDetail(row){
      let that = this
      this.showDetail = true;
      let obj = {
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.ResourceDetail.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      fetch.resourceList(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          fetch.remove({ role_id: row.id }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
    showchepaipage(){
      this.$router.push({
                path:"/chechang-wuye/jwsVehicleManage",
                query:{
                    id:this.queryParam.commId
                }
            })
    },
    showImportModal(){
        this.importmodal = true;
        this.videoDefaultList = [];
        this.videoList = [];
        this.$refs['ImageVideo'].fileList = [];
    },
    onUpdateVideo(val) {
          let videoList = [];
          val.forEach((ele, idx) => {
              videoList.push(ele.path);
          });
          this.videoList = videoList;
    },
    importExcel() {
      let that = this;
      console.log('importExcel:',this.videoList)
      fetch.importexcel({id:this.queryParam.commId,filepath:this.videoList[0]}).then((res) => {
             if (res.code == 200) {
              that.$message.success(res.message);
              that.importmodal == false;
            } else {
              that.$message.error(res.message);
            }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
